module.exports = __webpack_public_path__ + "static/media/ExMarkstheSpot_Bookcover.95412cd0.jpg";